import { render } from "./AppSelectedItemsList.vue?vue&type=template&id=e0fea348&scoped=true"
import script from "./AppSelectedItemsList.vue?vue&type=script&lang=js"
export * from "./AppSelectedItemsList.vue?vue&type=script&lang=js"

import "./AppSelectedItemsList.vue?vue&type=style&index=0&id=e0fea348&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0fea348"]])

export default __exports__